import { render, staticRenderFns } from "./RowSwitchReward.vue?vue&type=template&id=3ae4c81a&"
import script from "./RowSwitchReward.vue?vue&type=script&lang=ts&"
export * from "./RowSwitchReward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports